import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { useDetailParam } from "../utils/detailParam";
import { fetchProductById } from "../api/productService";
export var useProductActions = function () {
    var ky = useOkapiKy();
    var _a = useDetailParam(), detailId = _a.detailId, updateDetailParam = _a.updateDetailParam;
    var selectedProduct = useQuery(["product", detailId], function () { return fetchProductById(ky, detailId); }, {
        enabled: !!detailId,
    }).data;
    var handleRowClick = function (item) {
        updateDetailParam(item.id);
    };
    var handleCloseDetail = function () {
        updateDetailParam(null);
    };
    return {
        selectedProduct: selectedProduct,
        handleRowClick: handleRowClick,
        handleCloseDetail: handleCloseDetail,
    };
};
